export const NEW_TEMPLATE_TEMP_ID = 'new';
